/* Keep an existing member's newsletter choice through the sign-in link.

   Ghost only applies the newsletters picked at signup when it creates a NEW
   member. For an address it already has, the same form quietly becomes a
   sign-in: the "Welcome back" email, a login, and the boxes thrown away. Every
   Mailchimp import is an existing member, so ticking Prayer on /newsletters/
   did nothing for them (staging/signup-tests/results.md, 2026-10-03).

   What Ghost does keep is the page the request came from: the link in the
   email returns the reader to that URL, adding action=signin&success=true.
   So, at submit, the chosen newsletter ids go into the page's own URL
   (?hh_nl=id.id) just before Portal sends it. When the reader comes back
   signed in, this adds those newsletters to their account and shows them the
   result: on /subscribe/ that page's own list of their emails, elsewhere
   Portal's newsletter panel. It works in whatever browser the email app
   opens, because it travels in the link.

   It only ever ADDS: unticking the Herald on a signup form is not how an
   existing reader should be unsubscribed.

   A sign-in that carries no choice (Portal's own popup, which this cannot
   see into, if anything still opens it) still opens the newsletter panel, so a
   reader who meant to sign up lands where they can tick the boxes.

   Loads BEFORE subscribe-guard.js (gulp concatenates alphabetically), so its
   submit listener runs first even for a honeypot hit. That only rewrites the
   URL; the guard then stops the submit and nothing is sent. */
(function () {
    'use strict';

    var PARAM = 'hh_nl';
    var PANEL = '#/portal/account/newsletters';
    var API = '/members/api/member/';
    // page-subscribe.hbs shows a signed-in reader their own lists, so there it
    // is the confirmation and Portal's panel would only cover it up.
    var onSubscribePage = !!document.querySelector('[data-hh-subscribe-page]');

    function parseQuery(search) {
        var out = {};
        search.replace(/^\?/, '').split('&').forEach(function (pair) {
            if (!pair) {
                return;
            }
            var i = pair.indexOf('=');
            var key = decodeURIComponent(i === -1 ? pair : pair.slice(0, i));
            out[key] = i === -1 ? '' : decodeURIComponent(pair.slice(i + 1).replace(/\+/g, ' '));
        });
        return out;
    }

    // The current URL with `drop` keys removed and `add` keys set.
    function buildUrl(drop, add) {
        var q = parseQuery(window.location.search);
        var parts = [];
        var key;
        drop.forEach(function (k) {
            delete q[k];
        });
        for (key in add) {
            q[key] = add[key];
        }
        for (key in q) {
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(q[key]));
        }
        return window.location.pathname + (parts.length ? '?' + parts.join('&') : '');
    }

    // 1. At submit: write the choice into the URL Portal is about to send from.
    //    Capture phase, so it runs before Portal's own submit handler.
    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.hasAttribute || !form.hasAttribute('data-members-form') || !window.history.replaceState) {
            return;
        }
        var boxes = form.querySelectorAll('[data-hh-nl-id]');
        var ids = [];
        for (var i = 0; i < boxes.length; i++) {
            if (boxes[i].checked) {
                ids.push(boxes[i].getAttribute('data-hh-nl-id'));
            }
        }
        if (!ids.length) {
            return;
        }
        var add = {};
        add[PARAM] = ids.join('.');
        window.history.replaceState(window.history.state, '', buildUrl([PARAM], add) + window.location.hash);
    }, true);

    // 2. On the way back from the email. Read now, before Portal tidies the URL.
    var query = parseQuery(window.location.search);

    // A new member: Ghost has already applied their choice, so the id list in
    // the URL has done its job.
    if (query[PARAM] && query.success === 'true' && query.action !== 'signin') {
        window.history.replaceState(window.history.state, '', buildUrl([PARAM], {}) + window.location.hash);
        return;
    }

    if (query.action !== 'signin' || query.success !== 'true' || !window.fetch) {
        return;
    }

    var wanted = (query[PARAM] || '').split('.').filter(function (id) {
        return /^[0-9a-f]{24}$/.test(id);
    });

    if (!wanted.length) {
        if (!window.location.hash && !onSubscribePage) {
            window.location.hash = PANEL;
        }
        return;
    }

    // Whatever happens next, do it from a clean URL that shows the result. A
    // full reload, so the page and Portal start with the member as they now are.
    function finish() {
        if (onSubscribePage) {
            window.location.replace(window.location.pathname + '?hh_saved=1');
        } else {
            window.location.replace(buildUrl([PARAM, 'action', 'success'], {}) + PANEL);
        }
    }

    fetch(API, {credentials: 'same-origin'}).then(function (res) {
        if (res.status !== 200) {
            throw new Error('not signed in');
        }
        return res.json();
    }).then(function (member) {
        var have = (member.newsletters || []).map(function (n) {
            return n.id;
        });
        var missing = wanted.filter(function (id) {
            return have.indexOf(id) === -1;
        });
        if (!missing.length) {
            return null;
        }
        return fetch(API, {
            method: 'PUT',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                newsletters: have.concat(missing).map(function (id) {
                    return {id: id};
                })
            })
        });
    }).then(finish, finish);
})();
